(function () {
	"use strict";

	const header = document.querySelector(".m-header");
	const menuToggle = document.getElementById("mega-menu-toggle");
	const trigger = document.getElementById("mega-menu-trigger");
	const root = document.querySelector(".m-mega-menu-root");
	const megaMenu = root ? root.querySelector(".m-mega-menu") : null;
	const middleColumn = megaMenu
		? megaMenu.querySelector(".m-mega-menu-column-middle")
		: null;
	const imagesColumn = megaMenu
		? megaMenu.querySelector(".m-mega-menu-column-right")
		: null;
	const placeholderUrl = imagesColumn?.dataset.placeholderUrl || "";

	let menuOpen = false;

	function init() {
		initHeaderScrollState();
		initMenuControls();
		initAccordion(megaMenu, { onToggle: syncColumns });
		initAccordion(
			document.querySelector(
				".archive-products-column--menu .m-mega-menu-column-left",
			),
		);
		initImageHover();
		syncColumns();

		// Browsers may restore the checkbox state on back/forward navigation.
		if (menuToggle?.checked) {
			setMenuOpen(true);
		}
	}

	function initHeaderScrollState() {
		const threshold = 50;

		function onScroll() {
			header?.classList.toggle(
				"m-header--scrolled",
				window.scrollY > threshold,
			);
		}

		window.addEventListener("scroll", onScroll, { passive: true });
		onScroll();
	}

	/* --- Opening / closing the menu --- */

	function setMenuOpen(open) {
		menuOpen = open;

		// Keep the no-js fallback checkbox in sync.
		if (menuToggle) {
			menuToggle.checked = open;
		}

		root?.classList.toggle("m-mega-menu-root-visible", open);
		root?.setAttribute("aria-hidden", String(!open));
		megaMenu?.setAttribute("aria-hidden", String(!open));
		trigger?.setAttribute("aria-expanded", String(open));
		document.documentElement.classList.toggle("mega-menu-open", open);
		document.body.classList.toggle("mega-menu-open", open);

		if (open) {
			syncColumns();
		}
	}

	function initMenuControls() {
		trigger?.addEventListener("click", (event) => {
			event.preventDefault();
			setMenuOpen(!menuOpen);
		});

		root?.querySelectorAll(
			".m-mega-menu-overlay, .m-mega-menu-close",
		).forEach((control) => {
			control.addEventListener("click", () => setMenuOpen(false));
		});

		document.addEventListener("keydown", (event) => {
			if (event.key === "Escape" && menuOpen) {
				event.preventDefault();
				setMenuOpen(false);
			}
		});
	}

	/* --- Categories accordion (left column) --- */

	function initAccordion(container, options = {}) {
		const details = container?.querySelectorAll(
			".m-mega-menu-category-details",
		);
		if (!details?.length) return;

		details.forEach((detail) => {
			// The current category is pre-opened server-side; remove the CSS
			// max-height cap so long lists are not clipped.
			if (detail.open) {
				expandListFully(detail);
			}

			const summary = detail.querySelector("summary");
			if (!summary) return;

			summary.addEventListener("click", (event) => {
				event.preventDefault();

				const willOpen = !detail.open;

				// Exclusive accordion: at most one category open at a time.
				details.forEach((other) => {
					const shouldOpen = other === detail && willOpen;
					if (other.open !== shouldOpen) {
						other.open = shouldOpen;
						animateMobileList(other, shouldOpen);
					}
				});

				options.onToggle?.();
			});
		});
	}

	function expandListFully(detail) {
		const list = detail.querySelector(".m-mega-menu-subcategories-list");

		if (list) {
			list.style.maxHeight = "none";
			list.style.opacity = "1";
		}

		return list;
	}

	function animateMobileList(detail, open) {
		const list = detail.querySelector(".m-mega-menu-subcategories-list");
		if (!list) return;

		if (!open) {
			list.style.maxHeight = "";
			list.style.opacity = "";
			return;
		}

		expandListFully(detail);

		if (window.matchMedia("(min-width: 1024px)").matches) return;

		// Animate with WAAPI: CSS transitions are unreliable for content
		// that <details> has just revealed.
		list.animate(
			[
				{ maxHeight: "0px", opacity: 0 },
				{ maxHeight: `${list.scrollHeight}px`, opacity: 1 },
			],
			{ duration: 350, easing: "ease" },
		);
	}

	/* --- Desktop columns: subcategories list + decorative image --- */

	function syncColumns() {
		if (!megaMenu || !middleColumn) return;

		const openDetail = Array.from(
			megaMenu.querySelectorAll(".m-mega-menu-category-details"),
		).find((detail) => detail.open);
		const openIndex = openDetail ? openDetail.dataset.index : null;

		middleColumn.classList.toggle("is-visible", openIndex !== null);

		let activeList = null;
		megaMenu
			.querySelectorAll(".m-mega-menu-subcategories-list-desktop")
			.forEach((list) => {
				const isActive =
					openIndex !== null &&
					list.dataset.categoryIndex === openIndex;
				list.classList.toggle("is-active", isActive);
				if (isActive) {
					activeList = list;
				}
			});

		if (!imagesColumn) return;

		// Show a default image only when the open category contains
		// the currently viewed category page.
		const currentLink = activeList?.querySelector(
			".m-mega-menu-subcategories-link--current",
		);
		imagesColumn.dataset.defaultImageUrl = currentLink
			? currentLink.getAttribute("data-image-url") || placeholderUrl
			: "";
		showDefaultImage();
	}

	function showImage(url) {
		imagesColumn.style.setProperty(
			"--mega-menu-image-url",
			`url("${url}")`,
		);
		imagesColumn.classList.add("is-image-visible");
	}

	function showDefaultImage() {
		const url = imagesColumn.dataset.defaultImageUrl;

		if (url) {
			showImage(url);
			return;
		}

		imagesColumn.style.setProperty("--mega-menu-image-url", "none");
		imagesColumn.classList.remove("is-image-visible");
	}

	function initImageHover() {
		if (!megaMenu || !imagesColumn) return;

		megaMenu.addEventListener("mouseover", onPointerEnter);
		megaMenu.addEventListener("focusin", onPointerEnter);
		megaMenu.addEventListener("mouseout", onPointerLeave);
		megaMenu.addEventListener("focusout", onPointerLeave);

		function imageLinkFrom(target) {
			if (!(target instanceof Element)) return null;

			return target.closest(
				".m-mega-menu-subcategories-link, .m-mega-menu-brands-link",
			);
		}

		function onPointerEnter(event) {
			const link = imageLinkFrom(event.target);
			if (!link) return;

			showImage(link.getAttribute("data-image-url") || placeholderUrl);
		}

		function onPointerLeave(event) {
			const link = imageLinkFrom(event.target);
			if (!link) return;

			// Ignore movement within the same link.
			if (
				event.relatedTarget instanceof Element &&
				link.contains(event.relatedTarget)
			) {
				return;
			}

			showDefaultImage();
		}
	}

	window.auraMegaMenu = {
		open: () => setMenuOpen(true),
		close: () => setMenuOpen(false),
	};

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", init);
	} else {
		init();
	}
})();
